import { useMemo, useState } from 'react';
import DaySelector from '../components/DaySelector';
import ScheduleTimeline from '../components/ScheduleTimeline';
import RecommendedVisits from '../components/RecommendedVisits';
import { LEAP_DATES, SCHEDULE, RECOMMENDED_VISITS, SCHEDULE_SUMMARY } from '../data/schedule';
import { TRIP_INFO } from '../data/attendees';

function Home() {
  const [selectedDay, setSelectedDay] = useState('day1');
  const dayMeta = LEAP_DATES.find((d) => d.id === selectedDay);
  const items = useMemo(() => SCHEDULE[selectedDay] || [], [selectedDay]);

  const companyCountToday = useMemo(
    () => items.filter((item) => item.type === 'company').length,
    [items],
  );

  return (
    <div className="page home-page">
      <section className="hero-card">
        <div className="hero-content">
          <p className="hero-eyebrow">{TRIP_INFO.university}</p>
          <h1>{TRIP_INFO.event}</h1>
          <p className="hero-dates">{TRIP_INFO.dates} · {TRIP_INFO.hours}</p>
          <p className="hero-venue">
            <a
              href={TRIP_INFO.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="venue-link"
            >
              {TRIP_INFO.venue}
            </a>
          </p>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <span className="stat-value">4</span>
            <span className="stat-label">أيام</span>
          </div>
          <div className="stat">
            <span className="stat-value">{SCHEDULE_SUMMARY.maxCompanies}</span>
            <span className="stat-label">زيارة مجدولة</span>
          </div>
          <div className="stat">
            <span className="stat-value">5</span>
            <span className="stat-label">اتفاقيات</span>
          </div>
        </div>
      </section>

      <section className="schedule-section">
        <div className="section-header">
          <h2>الجدول اليومي</h2>
          <p>اختر يوماً لعرض خطة الوفد. جدول مريح — 3 زيارات شركات كحد أقصى يومياً.</p>
        </div>

        <DaySelector days={LEAP_DATES} selectedDay={selectedDay} onSelect={setSelectedDay} />

        {dayMeta && (
          <div className="day-summary">
            <div className="day-summary-header">
              <h3>{dayMeta.title}</h3>
              <span className={`priority-dots priority-${dayMeta.priority}`} title={`مستوى الأولوية ${dayMeta.priority}/5`}>
                {'🔥'.repeat(dayMeta.priority)}
              </span>
            </div>
            <p className="day-objective">{dayMeta.objective}</p>
            <p className="day-company-count">
              {companyCountToday} زيارة شركات مجدولة اليوم
            </p>
          </div>
        )}

        <ScheduleTimeline items={items} />
      </section>

      <RecommendedVisits visits={RECOMMENDED_VISITS} />
    </div>
  );
}

export default Home;
